"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOffers = getOffers;
exports.getHighestSalaryByRate = getHighestSalaryByRate;
exports.getSearchSuggestions = getSearchSuggestions;
exports.getPromotedOffers = getPromotedOffers;
exports.getAllPromotedOffers = getAllPromotedOffers;
exports.getOfferDetail = getOfferDetail;
exports.getSuggestedSameCompanyOffers = getSuggestedSameCompanyOffers;
exports.getSuggestedSimilarOffers = getSuggestedSimilarOffers;
exports.getAllOffersCount = getAllOffersCount;
const config_1 = __importDefault(require("@src/config"));
const types_1 = require("@src/types");
const axios_1 = require("./clients/axios");
async function getOffers(selectedFilterItems) {
    const response = await axios_1.client.get(`/0/offers`, {
        params: {
            typ: selectedFilterItems[types_1.OfferFilterType.type],
            loc: selectedFilterItems[types_1.OfferFilterType.location],
            job: selectedFilterItems[types_1.OfferFilterType.jobArea],
            salaryMin: selectedFilterItems[types_1.OfferFilterType.salaryMin],
            salaryMax: selectedFilterItems[types_1.OfferFilterType.salaryMax],
            salaryRate: selectedFilterItems[types_1.OfferFilterType.salaryRate],
            co: selectedFilterItems[types_1.OfferFilterType.searchCompaniesSelected],
            kw: selectedFilterItems[types_1.OfferFilterType.searchKeywordsSelected],
            page: selectedFilterItems.page,
        },
    });
    return response.data;
}
async function getHighestSalaryByRate(salaryRate) {
    const response = await axios_1.client.get('/0/offers/highest-salary', {
        params: {
            salaryRate,
        },
    });
    return response.data;
}
async function getSearchSuggestions(searchedText) {
    const response = await axios_1.client.get(`${config_1.default.api}/0/offers/search-suggestions`, {
        params: { searchedText },
    });
    return response.data;
}
async function getPromotedOffers(selectedFilterItems) {
    const response = await axios_1.client.get('/0/offers/promoted', {
        params: {
            typ: selectedFilterItems[types_1.OfferFilterType.type],
            loc: selectedFilterItems[types_1.OfferFilterType.location],
            job: selectedFilterItems[types_1.OfferFilterType.jobArea],
            salaryMin: selectedFilterItems[types_1.OfferFilterType.salaryMin],
            salaryMax: selectedFilterItems[types_1.OfferFilterType.salaryMax],
            salaryRate: selectedFilterItems[types_1.OfferFilterType.salaryRate],
            co: selectedFilterItems[types_1.OfferFilterType.searchCompaniesSelected],
            kw: selectedFilterItems[types_1.OfferFilterType.searchKeywordsSelected],
        },
    });
    return response.data;
}
async function getAllPromotedOffers() {
    const response = await axios_1.client.get('/0/offers/all-promoted');
    return response.data;
}
async function getOfferDetail({ offerId, offerSlug }) {
    const response = await axios_1.client.get('/0/offer', { params: { id: offerId, slug: offerSlug } });
    return response.data;
}
async function getSuggestedSameCompanyOffers(offerId) {
    const response = await axios_1.client.get('/0/offer-detail/offer-suggestions-company', { params: { offerId } });
    return response.data;
}
async function getSuggestedSimilarOffers(offerId) {
    const response = await axios_1.client.get('/0/offer-detail/offer-suggestions-similar', { params: { offerId } });
    return response.data;
}
async function getAllOffersCount() {
    return (await axios_1.client.get('/0/offers/count-all')).data;
}
